var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveForesee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FBBC05"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9248 20.3445C30.0258 20.1261 30.0258 19.874 29.9248 19.6556C29.8967 19.5947 29.217 18.1489 27.6562 16.7129C26.7411 15.8708 25.7068 15.1993 24.5819 14.7177C23.1806 14.1169 21.6391 13.8124 20.0005 13.8124C18.3619 13.8124 16.8204 14.1169 15.419 14.7173C14.2942 15.1993 13.2602 15.8705 12.3448 16.7125C10.7847 18.1486 10.1046 19.5947 10.0765 19.6556C9.97549 19.874 9.97549 20.1261 10.0765 20.3445C10.1046 20.4054 10.7843 21.8512 12.3451 23.2875C13.2602 24.1296 14.2945 24.8011 15.4194 25.2828C16.8207 25.8832 18.3622 26.1877 20.0008 26.1877C21.6394 26.1877 23.1809 25.8832 24.5823 25.2828C25.7071 24.8008 26.7411 24.1296 27.6565 23.2875C29.217 21.8515 29.8971 20.4054 29.9252 20.3445H29.9248ZM26.5012 22.1269C24.729 23.7351 22.5417 24.5503 20.0005 24.5503C17.4593 24.5503 15.2723 23.7348 13.4997 22.1269C12.585 21.2969 12.018 20.4555 11.7477 20C12.0183 19.544 12.5857 18.7025 13.4997 17.8732C15.272 16.265 17.4593 15.4497 20.0005 15.4497C22.5417 15.4497 24.729 16.2653 26.5012 17.8732C27.4153 18.7025 27.9826 19.544 28.2532 20C27.9826 20.4561 27.4153 21.2976 26.5012 22.1269Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 16.4968C18.072 16.4968 16.5037 18.0684 16.5037 19.9998C16.5037 21.9311 18.0723 23.5027 20.0001 23.5027C21.9279 23.5027 23.4966 21.9311 23.4966 19.9998C23.4966 18.0684 21.9279 16.4968 20.0001 16.4968ZM20.0001 21.866C18.973 21.866 18.1377 21.0288 18.1377 20.0001C18.1377 18.9714 18.9733 18.1342 20.0001 18.1342C21.0269 18.1342 21.8626 18.9714 21.8626 20.0001C21.8626 21.0288 21.0269 21.866 20.0001 21.866Z",
    fill: "#151515"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 12.375,
    fill: "white",
    transform: "translate(10 13.8125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveForesee);
export default __webpack_public_path__ + "static/media/ActiveForesee.56cededc36e1a0bf900a335b0362c5ab.svg";
export { ForwardRef as ReactComponent };